import blog2 from "../../components/assests/blog_images/Adoption of the MERN stack.jpg";
import {
    default as blog1,
    default as blog5,
} from "../../components/assests/blog_images/how much need js.jpg";
import blog4 from "../../components/assests/blog_images/The relationship between programming and development.png";
import blog6 from "../../components/assests/blog_images/The routine of becoming a junior web developer in 14 weeks.jpg";

export const initialState = [
    {
        id: 1,
        img: blog1,
        title: "How much JavaScript do you need to know before starting to learn React?",
        author: "Jhankar mahbub",
        time: "July 27, 2022 . 20 min read",
        category: "Web Development",
        authorImg:
            "https://scontent.fdac27-1.fna.fbcdn.net/v/t1.6435-9/120894323_197059875119957_6342630029659575816_n.jpg?_nc_cat=109&ccb=1-7&_nc_sid=09cbfe&_nc_eui2=AeE0HiGfkr8mAiWpo9XPnkvmKV-wUZZMoFspX7BRlkygW6-PwN11e9epV1GU-SdxzQovaDTrXt4Z5-i0mdB-hdW_&_nc_ohc=TNE9-gT8lI8AX-pACuv&_nc_ht=scontent.fdac27-1.fna&oh=00_AT-ryjtYDkT6_lv3zMuhGmho5YEtUxDliEWncE6r00vg4Q&oe=63281400",
    },
    {
        id: 2,
        img: blog2,
        title: "Adoption of the MERN stack",
        author: "Jhankar mahbub",
        time: "July 17, 2022 . 20 min read",
        category: "Web Development",
        authorImg:
            "https://scontent.fdac27-1.fna.fbcdn.net/v/t1.6435-9/120894323_197059875119957_6342630029659575816_n.jpg?_nc_cat=109&ccb=1-7&_nc_sid=09cbfe&_nc_eui2=AeE0HiGfkr8mAiWpo9XPnkvmKV-wUZZMoFspX7BRlkygW6-PwN11e9epV1GU-SdxzQovaDTrXt4Z5-i0mdB-hdW_&_nc_ohc=TNE9-gT8lI8AX-pACuv&_nc_ht=scontent.fdac27-1.fna&oh=00_AT-ryjtYDkT6_lv3zMuhGmho5YEtUxDliEWncE6r00vg4Q&oe=63281400",
    },
    {
        id: 3,
        img: "https://images.unsplash.com/photo-1505685296765-3a2736de412f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1740&q=80",
        title: "What is CSS?? Its history and present status.",
        author: "Mir Hossain",
        time: "August 22, 2022 . 3 min read",
        category: "CSS",
        authorImg:
            "https://scontent.fdac27-1.fna.fbcdn.net/v/t39.30808-6/296999936_379623804296362_5374625346354595059_n.jpg?_nc_cat=109&ccb=1-7&_nc_sid=09cbfe&_nc_eui2=AeGELRt0H3B__vyoNsKbxpz6dNKKHgbz29t00ooeBvPb2-78lML9bHCImKVlcObBBk4LTEw4ErsC8eo7dj_zVCqh&_nc_ohc=qdSaPgCCmUcAX9ajyBX&_nc_ht=scontent.fdac27-1.fna&oh=00_AT9jp3ZFiKdgD5mw8N69eVMXIX8-cy2YJnAqFq13yvAYnQ&oe=6308CA77",
    },
    {
        id: 4,
        img: blog4,
        title: "The relationship between programming and development",
        author: "Emdadul Hoque Tareque",
        time: "August 22, 2022 . 3 min read",
        category: "Programming",
        authorImg:
            "https://scontent.fdac27-2.fna.fbcdn.net/v/t39.30808-6/293643895_5257455917683561_347579848857232937_n.jpg?_nc_cat=103&ccb=1-7&_nc_sid=09cbfe&_nc_eui2=AeFuXjbPua-9fcGjGnYK8nalDCLWDhZXlV8MItYOFleVX3QZJipf0Z6pTmrkGeQRIsngspGpF-xwuAo5Nrsc3rjf&_nc_ohc=OSJW2oAUsCMAX86Kdoh&_nc_ht=scontent.fdac27-2.fna&oh=00_AT9IcAxM3cYiV5bFIctcYBRtCaua4InKFq9ngGyqzE34PA&oe=6308918C",
    },
    {
        id: 5,
        img: blog5,
        title: "How to start programming?",
        author: "Emdadul Hoque Tareque",
        time: "August 16, 2022 . 7 min read",
        category: "Programming",
        authorImg:
            "https://scontent.fdac27-2.fna.fbcdn.net/v/t39.30808-6/293643895_5257455917683561_347579848857232937_n.jpg?_nc_cat=103&ccb=1-7&_nc_sid=09cbfe&_nc_eui2=AeFuXjbPua-9fcGjGnYK8nalDCLWDhZXlV8MItYOFleVX3QZJipf0Z6pTmrkGeQRIsngspGpF-xwuAo5Nrsc3rjf&_nc_ohc=OSJW2oAUsCMAX86Kdoh&_nc_ht=scontent.fdac27-2.fna&oh=00_AT9IcAxM3cYiV5bFIctcYBRtCaua4InKFq9ngGyqzE34PA&oe=6308918C",
    },
    {
        id: 6,
        img: blog6,
        title: "The routine of becoming a junior web developer in 14 weeks",
        author: "Jhankar Mahbub",
        time: "August 22, 2022 . 11 min read",
        category: "Web Development",
        authorImg:
            "https://scontent.fdac27-1.fna.fbcdn.net/v/t1.6435-9/120894323_197059875119957_6342630029659575816_n.jpg?_nc_cat=109&ccb=1-7&_nc_sid=09cbfe&_nc_eui2=AeE0HiGfkr8mAiWpo9XPnkvmKV-wUZZMoFspX7BRlkygW6-PwN11e9epV1GU-SdxzQovaDTrXt4Z5-i0mdB-hdW_&_nc_ohc=TNE9-gT8lI8AX-pACuv&_nc_ht=scontent.fdac27-1.fna&oh=00_AT-ryjtYDkT6_lv3zMuhGmho5YEtUxDliEWncE6r00vg4Q&oe=63281400",
    },
];
